import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { FileAccessTypes, FileTypes, ImageContextTypes, ImageFileRepository } from './domain'

import { SolarResponse, SolarResponseRefiner } from '../../foundation'

type DownloadUrl = string

export class ImageRepository implements ImageFileRepository {
  constructor(private axios: AxiosInstance) {}

  upload = async (files: File[], type?: string): Promise<string[] | null> => {
    const command = this.formatToFromData(files)

    if (type) {
      command.append('type', type)
    }

    const config: AxiosRequestConfig = {
      url: '/upload',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: command,
    }

    const { data: response } = await this.axios.request<SolarResponse<null | string[]>>(config)
    return new SolarResponseRefiner(response).handle()
  }

  private formatToFromData = (imageFiles: File[]): FormData => {
    const form = new FormData()
    imageFiles.forEach((file) => {
      form.append('images', file)
    })
    return form
  }

  /**
   *  https://www.notion.so/healingpaper/a3861850428e4afd9f4e7f44bb31ed18?pvs=4#20219b3c123c42e6bea6decff73e21f9
   */
  uploadImage = async (
    fileName: string,
    file: File,
    context: ImageContextTypes,
    fileAccessType: FileAccessTypes,
    fileType: FileTypes,
  ): Promise<DownloadUrl> => {
    const responsedUrls = await this.getImageUploadUrl(fileName, context, fileAccessType, fileType)
    if (!responsedUrls) {
      return ''
    }

    const { downloadUrl, uploadUrl } = responsedUrls
    const myHeaders = new Headers({
      'Content-Type': file.type,
      'Access-Control-Allow-Origin': '*',
      'x-amz-acl': fileAccessType === FileAccessTypes.PUBLIC ? 'public-read' : 'private',
    })

    await fetch(uploadUrl, {
      method: 'PUT',
      headers: myHeaders,
      body: file,
    })

    return downloadUrl
  }

  private getImageUploadUrl = async (
    fileName: string,
    context: ImageContextTypes,
    fileAccessType: FileAccessTypes,
    fileType: FileTypes,
  ): Promise<{ downloadUrl: string; uploadUrl: string } | null> => {
    const config: AxiosRequestConfig = {
      url: `/storage/queries/file-upload-url/process`,
      method: 'get',
      params: {
        context,
        fileType,
        fileAccessType,
        fileName,
      },
    }

    const response = await this.axios.request<{ downloadUrl: string; uploadUrl: string }>(config)
    return response.data
  }
}
